import { map } from 'rxjs';
import getUnixTime from 'date-fns/getUnixTime';
import { ADMIN_API } from '../AdminAPI';
import { createBranch, Branch } from '@golden/gdk-base';
import { convertUnixToDate } from '@golden/utils';
export function createPlayerService(api, trunk) {
    return {
        layers: createBranch({
            trunk,
            branch: Branch.PLAYER_LAYER,
            value: [],
            operator: () => api.fetch(ADMIN_API.GET_PLAYER_LAYER_SIMPLE_LIST)
        }),
        getPlayerList(payload) {
            const data = { ...payload };
            if (payload.start_at) {
                data.start_at = getUnixTime(payload.start_at);
            }
            if (payload.end_at) {
                data.end_at = getUnixTime(payload.end_at);
            }
            return api.fetch(ADMIN_API.GET_PLAYER_LIST, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'created_at', 'last_login_at'))
            })));
        },
        getPlayerCenter(id) {
            return api.fetch(ADMIN_API.GET_PLAYER_CENTER, { config: { urlParams: { id } } });
        },
        updatePlayerCenter(id, data) {
            return api.fetch(ADMIN_API.PUT_PLAYER_CENTER, { data, config: { urlParams: { id } } });
        },
        getPlayerGoubao(id) {
            return api.fetch(ADMIN_API.GET_PLAYER_GOUBAO, { config: { urlParams: { id } } }).pipe(map((res) => convertUnixToDate(res, 'goubao_registered_at', 'last_bought_at')));
        },
        getPlayerWithdrawalAccounts(id) {
            return api.fetch(ADMIN_API.GET_PLAYER_WITHDRAWAL_ACCOUNTS, { config: { urlParams: { id } } }).pipe(map((res) => ({
                ...res,
                accounts: {
                    binding: res.accounts.binding.map(item => ({
                        ...convertUnixToDate(item, 'created_at', 'deleted_at'),
                        related_records: item.related_records.map((el) => convertUnixToDate(el, 'created_at', 'deleted_at'))
                    })),
                    bound: res.accounts.bound.map(item => ({
                        ...convertUnixToDate(item, 'created_at', 'deleted_at'),
                        related_records: item.related_records.map((el) => convertUnixToDate(el, 'created_at', 'deleted_at'))
                    }))
                }
            })));
        },
        createPlayerWithdrawalAccount(id, data) {
            return api.fetch(ADMIN_API.POST_PLAYER_WITHDRAWAL_ACCOUNT, { config: { urlParams: { id } }, data });
        },
        deletePlayerWithdrawalAccount(id, accountId) {
            return api.fetch(ADMIN_API.DELETE_PLAYER_WITHDRAWAL_ACCOUNTS, { config: { urlParams: { id, accountId } } });
        },
        validatePlayerDebitCard(data) {
            return api.fetch(ADMIN_API.VALIDATE_PLAYER_DEBIT_CARD, { data });
        },
        getPlayerDebitCards(id) {
            return api.fetch(ADMIN_API.GET_PLAYER_DEBIT_CARDS, { config: { urlParams: { id } } }).pipe(map((res) => ({
                binding: res.binding.map(item => ({
                    ...convertUnixToDate(item, 'created_at', 'deleted_at'),
                    related_records: item.related_records.map((el) => convertUnixToDate(el, 'created_at', 'deleted_at'))
                })),
                bound: res.bound.map(item => ({
                    ...convertUnixToDate(item, 'created_at', 'deleted_at'),
                    related_records: item.related_records.map((el) => convertUnixToDate(el, 'created_at', 'deleted_at'))
                }))
            })));
        },
        createPlayerDebitCards(id, data) {
            return api.fetch(ADMIN_API.POST_PLAYER_DEBIT_CARDS, { config: { urlParams: { id } }, data });
        },
        updatePlayerDebitCard(id, cardId, data) {
            return api.fetch(ADMIN_API.PUT_PLAYER_DEBIT_CARDS, { config: { urlParams: { id, cardId } }, data });
        },
        deletePlayerDebitCard(id, cardId) {
            return api.fetch(ADMIN_API.DELETE_PLAYER_DEBIT_CARDS, { config: { urlParams: { id, cardId } } });
        },
        getPlayerCryptoWallet(id) {
            return api.fetch(ADMIN_API.GET_PLAYER_CRYPTO_WALLETS, { config: { urlParams: { id } } }).pipe(map((res) => ({
                ...res,
                wallets: {
                    binding: res.wallets.binding.map(item => ({
                        ...convertUnixToDate(item, 'created_at', 'deleted_at'),
                        related_records: item.related_records.map((el) => convertUnixToDate(el, 'created_at', 'deleted_at'))
                    })),
                    bound: res.wallets.bound.map(item => ({
                        ...convertUnixToDate(item, 'created_at', 'deleted_at'),
                        related_records: item.related_records.map((el) => convertUnixToDate(el, 'created_at', 'deleted_at'))
                    }))
                }
            })));
        },
        deletePlayerCryptoWallet(id, walletId) {
            return api.fetch(ADMIN_API.DELETE_PLAYER_CRYPTO_WALLETS, { config: { urlParams: { id, walletId } } });
        },
        setPlayerDebitCardBlacklist(id, cardId, memo) {
            return api.fetch(ADMIN_API.POST_PLAYER_DEBIT_CARDS_BLACKLIST, { config: { urlParams: { id, cardId } }, data: { memo } });
        },
        getPlayerGameStatus(id) {
            return api.fetch(ADMIN_API.GET_PLAYER_GAME_STATUS, { config: { urlParams: { id } } });
        },
        getPlayerInfo(id) {
            return api.fetch(ADMIN_API.GET_PLAYER_INFO, { config: { urlParams: { id } } }).pipe(map((res) => ({
                ...convertUnixToDate(res, 'created_at', 'last_login_at'),
                jump_ship_history: res.jump_ship_history.map(item => ({
                    ...convertUnixToDate(item, 'processed_at')
                })),
            })));
        },
        getPlayerSetting(id) {
            return api.fetch(ADMIN_API.GET_PLAYER_SETTING, { config: { urlParams: { id } } });
        },
        updatePlayerSetting(id, data) {
            return api.fetch(ADMIN_API.PUT_PLAYER_SETTING, { config: { urlParams: { id } }, data });
        },
        getPlayerTransaction(id) {
            return api.fetch(ADMIN_API.GET_PLAYER_TRANSACTIONS, { config: { urlParams: { id } } }).pipe(map((res) => ({
                deposit: convertUnixToDate(res.deposit, 'last_at'),
                withdraw: convertUnixToDate(res.withdraw, 'last_at'),
                bet: convertUnixToDate(res.bet, 'last_at')
            })));
        },
        getPlayerBetHistoryStatistic(id) {
            return api.fetch(ADMIN_API.GET_PLAYER_BET_HSITROY_STATISTIC, { config: { urlParams: { id } } });
        },
        getPlayerCashLogStatistic(id) {
            return api.fetch(ADMIN_API.GET_PLAYER_CASH_LOG_STATISTIC, { config: { urlParams: { id } } });
        },
        updatePlayerNickname(id, nickname) {
            return api.fetch(ADMIN_API.POST_PLAYER_NICKNAME, { config: { urlParams: { id } }, data: { nickname } });
        },
        updatePlayerPhone(id, idd_code, phone) {
            return api.fetch(ADMIN_API.POST_PLAYER_PHONE, { config: { urlParams: { id } }, data: { idd_code, phone } });
        },
        validatePlayerPhone(id, idd_code, phone, code) {
            return api.fetch(ADMIN_API.POST_PLAYER_PHONE_VALIDATE, { config: { urlParams: { id } }, data: { idd_code, phone, code } });
        },
        updateEmail(id, email) {
            return api.fetch(ADMIN_API.POST_PLAYER_EMAIL, { config: { urlParams: { id } }, data: { email } });
        },
        updateInfoMemo(id, data) {
            return api.fetch(ADMIN_API.POST_PLAYER_INFO_MEMO, { config: { urlParams: { id } }, data });
        },
        validateIdentity(data) {
            return api.fetch(ADMIN_API.POST_ELEMENT_FOUR, { data });
        },
        getPlayerRankList() {
            return api.fetch(ADMIN_API.GET_PLAYER_RANK_LIST).pipe(map((res) => res.map((item) => convertUnixToDate(item, 'updated_at'))));
        },
        getPlayerRank(id) {
            return api.fetch(ADMIN_API.GET_PLAYER_RANK, { config: { urlParams: { id } } }).pipe(map((res) => convertUnixToDate(res, 'updated_at')));
        },
        getPlayerRankUser(account) {
            return api.fetch(ADMIN_API.GET_PLAYER_RANK_USER, { data: { account } });
        },
        getPlayerRankActivity() {
            return api.fetch(ADMIN_API.GET_PLAYER_RANK_ACTIVITY);
        },
        setPlayerRank(id, rank) {
            return api.fetch(ADMIN_API.PUT_PLAYER_RANK_USER, { data: { slug: rank }, config: { urlParams: { id } } });
        },
        getPlayerLayerList() {
            return api.fetch(ADMIN_API.GET_PLAYER_LAYER_LIST).pipe(map((res) => ({
                ...convertUnixToDate(res, 'layer_start_at'),
                layers: res.layers.map((item) => convertUnixToDate(item, 'updated_at'))
            })));
        },
        updatePlayerRank(id, data) {
            return api.fetch(ADMIN_API.PUT_PLAYER_RANK, { data, config: { urlParams: { id } } });
        },
        getPlayerLayer(id) {
            return api.fetch(ADMIN_API.GET_PLAYER_LAYER, { config: { urlParams: { id } } }).pipe(map((res) => convertUnixToDate(res, 'updated_at')));
        },
        updatePlayerLayer(id, data) {
            return api.fetch(ADMIN_API.PUT_PLAYER_LAYER, { data, config: { urlParams: { id } } });
        },
        lockPlayerLayer(data) {
            return api.fetch(ADMIN_API.POST_LOCKED_PLAYERS, { data });
        },
        unlockPlayerLayer(data) {
            return api.fetch(ADMIN_API.POST_UNLOCKED_PLAYERS, { data });
        },
        stratifyLayer() {
            return api.fetch(ADMIN_API.POST_LAYER_STRATIFY_LAYER);
        },
        resetLayerStartAt() {
            return api.fetch(ADMIN_API.POST_LAYER_RESET_LAYER_START_AT);
        },
        searchPlayerLayer(account) {
            return api.fetch(ADMIN_API.GET_PLAYER_LAYER_SEARCH, { data: { account } });
        },
        searchPlayer(account) {
            return api.fetch(ADMIN_API.POST_SEARCH_PLAYER, { data: { account } });
        },
        getRankEffectiveBetRecords(payload) {
            const data = payload.start_at && payload.end_at
                ? {
                    ...payload,
                    start_at: getUnixTime(payload.start_at),
                    end_at: getUnixTime(payload.end_at)
                }
                : payload;
            return api.fetch(ADMIN_API.GET_PLAYER_RANK_EFFECTIVE_BETS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((el) => convertUnixToDate(el, 'updated_at'))
            })));
        },
        getRankLog(payload) {
            const data = payload.start_at && payload.end_at
                ? {
                    ...payload,
                    start_at: getUnixTime(payload.start_at),
                    end_at: getUnixTime(payload.end_at)
                }
                : payload;
            return api.fetch(ADMIN_API.GET_PLAYER_RANK_LOG, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => convertUnixToDate(item, 'updated_at'))
            })));
        },
        deductRankEffectiveBet(id, data) {
            return api.fetch(ADMIN_API.POST_PLAYER_RANK_EFFECTIVE_BETS, { config: { urlParams: { id } }, data });
        },
        revokeDeductedRankEffectiveBet(id) {
            return api.fetch(ADMIN_API.POST_PLAYER_RANK_EFFECTIVE_BETS_REVOKE, { config: { urlParams: { id } } });
        },
        getOperationLogs(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(ADMIN_API.GET_PLAYER_OPERATION_LOGS, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((el) => convertUnixToDate(el, 'operated_at'))
            })));
        },
        getPlayerCGPayDetail(id) {
            return api.fetch(ADMIN_API.GET_PLAYER_CGPay_Detail, { config: { urlParams: { user: id } } });
        },
        getPlayerRelations(user) {
            return api.fetch(ADMIN_API.GET_PLAYER_RELATIONS, { config: { urlParams: { user } } }).pipe(map((res) => ({
                ...res,
                data: res.data.map((el) => convertUnixToDate(el, 'updated_at', 'last_bet_at'))
            })));
        },
        addPlayerRelations(data, user) {
            return api.fetch(ADMIN_API.POST_PLAYER_RELATIONS, { data, config: { urlParams: { user } } });
        },
        editPlayerRelations(data, params) {
            return api.fetch(ADMIN_API.PUT_PLAYER_RELATIONS, { data, config: { urlParams: params } });
        },
        deletePlayerRelations(params) {
            return api.fetch(ADMIN_API.DELETE_PLAYER_RELATIONS, { config: { urlParams: params } });
        },
        getAgentMemoList(data) {
            return api.fetch(ADMIN_API.GET_AGENT_MEMO_LIST, { data });
        },
        getAgentMemo(data, params) {
            return api.fetch(ADMIN_API.GET_AGENT_MEMO, { data, config: { urlParams: params } });
        },
        addAgentMemo(data) {
            return api.fetch(ADMIN_API.POST_AGENT_MEMO, { data });
        },
        validateAgentMemoExist(data) {
            return api.fetch(ADMIN_API.POST_VALIDATE_AGENT_MEMO_EXSIT, { data });
        },
        updateAgentMemo(data, params) {
            return api.fetch(ADMIN_API.UPDATE_AGENT_MEMO, { data, config: { urlParams: params } });
        },
        deleteAgentMemo(data, params) {
            return api.fetch(ADMIN_API.DELETE_AGENT_MEMO, { data, config: { urlParams: params } });
        }
    };
}
//# sourceMappingURL=PlayerService.js.map